import React from 'react'

interface IconProps {
  className?: string
}

const ForkKnife = ({ className }: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M20 22V15.6842M7.2 9.36842C8.96731 9.36842 10.4 7.95458 10.4 6.21053V2M7.2 9.36842C5.43269 9.36842 4 7.95458 4 6.21053V2M7.2 9.36842V22M7.2 9.36842V2M20 15.6842V8.31579V5.15789V2C20 2 15.7333 4.63158 15.7333 8.84211C15.7333 13.5789 20 15.6842 20 15.6842Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ForkKnife
